import React, { useState, useContext, useRef } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import moment from "moment/moment";
import Customer_invoice_item_ledger_modal from "./customer_invoice_item_ledger_modal";

const Customer_invoice_ledger_table = ({invoice}) => {
    const [invoice_detail, setinvoice_detail] = useState({});
    const [show, setshow] = useState(false);
    return (
        <div>
            <Customer_invoice_item_ledger_modal show={show} setshow={setshow} invoice_detail={invoice_detail} />
            {/* Expense List Card */}
                <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto"> 
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                    <h2 className="text-base font-semibold text-slate-800">لیستی وەسڵەکانی کڕیار</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                <thead>
                    <tr className="bg-slate-50 border-b border-slate-100">
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        ژمارەی وەسڵ
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        کڕیار
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        جۆری وەسڵ
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        بەروار
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        داشکاندن
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        نرخی دۆلار
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        کۆی نرخی پسوڵە
                        </th>
                        <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                        بڕی واسڵکراو
                        </th>
                    </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                    {invoice?.map((lis, index) => (
                        <tr
                        key={index}
                        className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                        onClick={() => {
                            var temp_items=lis.items.map((item) => {
                            return {
                                ...item,
                                item_unit_one_qty: (Number(item.item_qty)-Number(Math.floor(item.item_qty))) * Number(item.item_unit_one_of_many),
                                item_unit_many_qty: Math.floor(item.item_qty),
                            }
                            });
                            var temp_invoice_detail = {
                            ...lis,
                            items: temp_items,
                            };
                            setinvoice_detail(temp_invoice_detail);
                            setshow(true);
                        }}
                        >
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.sell_invoice_id}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.sell_invoice_customer_name}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {lis.sell_invoice_type=="loan"?"قەرز":"کاش"}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {moment(lis.sell_invoice_date).format("YYYY-MM-DD hh:mm A")}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {numberbeautify(lis.sell_invoice_discount)}%
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {numberbeautify(lis.sell_invoice_dollar_price)}
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {numberbeautify(
                                money_rounding(
                                Number(lis.items.reduce((acc, item) => {
                                return acc + (item.item_sell_state=="pay"? (item.item_sell_price * item.item_qty):0);
                            }
                            , 0))*(1-lis.sell_invoice_discount/100)))
                            } $
                        </td>
                        <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                            {
                                lis.sell_invoice_type=="loan"?
                                numberbeautify(money_rounding(lis.sell_invoice_loan_in_amount))+" $":
                                "-"
                            }
                        </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>
            </div>
    )
}

export default Customer_invoice_ledger_table